import { LegendItem } from "../types/statistics.types";
import { ReactComponent as CheckIcon } from '../assets/icons/check-input.svg';
import './line-chart.legend-item.scss';

interface LineChartLegendItemProps {
    item: LegendItem;
}

const LineChartLegendItem: React.FC<LineChartLegendItemProps> = ({ item }) => {

    const gradientStyle = {
        background: item.selected ? `linear-gradient(90deg, ${item.colors[0]} 44%, ${item.colors[1]} 100%)` : 'rgba(27, 31, 38, 0.72)',
    };

    return (
        <div className="line-chart-legend-item flex-row flex-gap-5">
            <div className="checkbox">
                <div className="check-container" style={gradientStyle}>
                
                </div>
                    {item.selected &&
                        <div className="check">
                            <CheckIcon width={10} height={10}/>
                        </div>
                    }
            </div>
            {item.label}
        </div>
    )
}

export default LineChartLegendItem;



